var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFavourite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_69_2265)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.5 2.4165C16.3739 2.43402 15.2724 2.74836 14.3067 3.32778C13.341 3.90719 12.5453 4.73117 12 5.7165C11.4546 4.73117 10.6589 3.90719 9.6932 3.32778C8.7275 2.74836 7.62601 2.43402 6.49996 2.4165C4.7049 2.49449 3.01366 3.27976 1.79574 4.60074C0.577818 5.92171 -0.0677922 7.67103 -4.17093e-05 9.4665C-4.17093e-05 14.0135 4.78596 18.9795 8.79996 22.3465C9.69618 23.0996 10.8293 23.5125 12 23.5125C13.1706 23.5125 14.3037 23.0996 15.2 22.3465C19.214 18.9795 24 14.0135 24 9.4665C24.0677 7.67103 23.4221 5.92171 22.2042 4.60074C20.9863 3.27976 19.295 2.49449 17.5 2.4165Z",
    fill: "#FF574C"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_69_2265"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavourite);
export default __webpack_public_path__ + "static/media/Favourite.75c360275ef065faf147c47b2b14068c.svg";
export { ForwardRef as ReactComponent };